var _rect, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 89,
    viewBox: "0 0 218 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_373_18973)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 219,
    height: 90,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.6821 30.2596L214.496 53.5334C219.804 54.3525 223.517 59.218 222.906 64.5539L220.049 89.5053C219.49 94.3964 215.453 98.1523 210.534 98.359L10.7596 106.755C7.15369 106.906 3.74586 105.103 1.84283 102.036L-24.2883 59.9271C-27.998 53.9491 -24.5383 46.1109 -17.6217 44.8232L60.3267 30.3115C61.4343 30.1053 62.5687 30.0878 63.6821 30.2596Z",
    fill: "url(#paint0_linear_373_18973)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_373_18973)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_373_18973",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 14,
    width: 59,
    height: 70
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.351 83.0961H85.6491C82.5295 83.0961 80 80.5748 80 77.4642V19.6772C80 16.5666 82.5295 14.0449 85.6491 14.0449H133.351C136.47 14.0449 139 16.5666 139 19.6772V77.4642C139 80.5748 136.47 83.0961 133.351 83.0961Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_373_18973)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.351 83.0961H85.6491C82.5295 83.0961 80 80.5748 80 77.4642V19.6772C80 16.5666 82.5295 14.0449 85.6491 14.0449H133.351C136.47 14.0449 139 16.5666 139 19.6772V77.4642C139 80.5748 136.47 83.0961 133.351 83.0961Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.691 55.7423H111.364V55.0746H106.691V55.7423Z",
    fill: "#89C0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9968 64.4221H116.038V62.7529H88.9968V64.4221Z",
    fill: "#89C0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9968 72.4342H111.03V70.765H88.9968V72.4342Z",
    fill: "#89C0FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9968 68.4282H102.017V66.759H88.9968V68.4282Z",
    fill: "#89C0FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1775 50.5719H89.3298V56.0762H95.1678V55.2328H90.1775V50.5719ZM128.21 50.5719V55.2328H123.219V56.0762H129.057V50.5719H128.21ZM89.3304 26.5262H90.178V21.8662H95.1683V21.0229H89.3304V26.5262ZM123.219 21.0229V21.8662H128.21V26.5262H129.057V21.0229H123.219Z",
    fill: "#89C0FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.054 47.0625H121.474C121.107 44.3869 120.656 41.3327 120.656 41.3327C120.656 41.3327 120.431 43.8532 120.156 47.0625H97.8308C97.6271 44.1763 97.3819 42.0173 97.2931 41.9732C97.1652 41.9088 96.3685 44.4693 95.7078 47.0625H89.6637C91.2181 40.356 94.1175 29.596 95.7941 28.9515C98.1795 28.0323 107.91 25.0289 107.91 25.0289H113.463C113.463 25.0289 123.329 27.8484 124.247 30.9139C124.977 33.3569 126.587 41.4126 127.054 47.0625Z",
    fill: "#91D8BA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.226 7.05005C111.226 7.05005 116.411 7.86312 115.622 15.9384C114.832 24.0136 110.256 23.3517 109.95 23.3435C109.644 23.3353 105.355 23.4908 105.021 13.6314C105.021 13.6314 104.874 6.34078 111.226 7.05005Z",
    fill: "#EEA987"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.172 21.2468C113.172 21.2468 113.032 24.6289 113.351 25.3611C113.669 26.0933 109.127 28.445 106.356 25.8242C106.356 25.8242 107.025 22.1486 106.84 20.8459C106.653 19.5431 113.172 21.2468 113.172 21.2468Z",
    fill: "#EEA987"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.643 13.9528C115.643 13.9528 116.158 13.3301 116.347 13.9605C116.536 14.5909 115.548 17.4078 115.613 17.5342C115.613 17.5342 115.518 17.7786 115.395 17.644C115.271 17.5094 115.643 13.9528 115.643 13.9528Z",
    fill: "#EEA987"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.793 13.6276C104.793 13.6276 104.259 12.9957 104.048 13.6199C103.837 14.2441 104.831 17.073 104.761 17.1976C104.761 17.1976 104.856 17.4434 104.989 17.3119C105.122 17.1804 104.793 13.6276 104.793 13.6276Z",
    fill: "#EEA987"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.671 15.2101L114.926 16.215C114.926 16.215 114.946 14.0118 114.827 13.6663C114.707 13.3209 114.524 12.2655 114.425 12.0166C114.325 11.7678 109.956 10.5324 106.097 12.3773C106.097 12.3773 106.267 13.9616 105.897 14.1026C105.527 14.2436 105.708 16.6829 105.708 16.6829L105.096 15.9855C105.096 15.9855 104.158 9.66501 104.39 9.00622C104.622 8.34742 105.359 4.38676 113.276 6.73795C113.276 6.73795 115.744 6.21042 116.24 7.92987C116.735 9.64925 115.671 15.2101 115.671 15.2101Z",
    fill: "#D98B52"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.582 25.0542C113.582 25.0542 114.72 25.3059 109.96 30.0365C109.96 30.0365 106.584 26.1636 106.693 25.5149C106.803 24.8663 113.582 25.0542 113.582 25.0542Z",
    fill: "#EEA987"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.028 30.0639L111.375 32.3734L115.37 25.5713L113.639 24.3612L110.028 30.0639Z",
    fill: "#24B275"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.028 30.1191L106.832 25.0289L105.021 26.1944L108.269 32.3734L110.028 30.1191Z",
    fill: "#24B275"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.922 44.3243C108.962 45.0841 108.981 46.0163 108.983 47.0624H108.796C108.795 46.0204 108.777 45.0906 108.736 44.3333C108.431 38.6191 109.837 31.6661 109.846 30.0365L110.028 30.0719C110.019 31.7014 108.617 38.6346 108.922 44.3243Z",
    fill: "#24B275"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.691 22.5584C107.691 22.5584 108.966 23.9389 110.767 23.5708C112.568 23.2026 113.367 22.3582 113.367 22.3582C113.367 22.3582 112.656 24.184 110.575 24.3511C108.492 24.5182 107.691 22.5584 107.691 22.5584Z",
    fill: "#C78D71"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M129.5 64C125.909 64 123 66.9093 123 70.5C123 74.0907 125.909 77 129.5 77C133.091 77 136 74.0907 136 70.5C136 66.9093 133.091 64 129.5 64ZM133.274 71.2339C133.274 71.4069 133.133 71.5484 132.96 71.5484H130.548V73.9597C130.548 74.1327 130.407 74.2742 130.234 74.2742H128.766C128.593 74.2742 128.452 74.1327 128.452 73.9597V71.5484H126.04C125.867 71.5484 125.726 71.4069 125.726 71.2339V69.7661C125.726 69.5931 125.867 69.4516 126.04 69.4516H128.452V67.0403C128.452 66.8673 128.593 66.7258 128.766 66.7258H130.234C130.407 66.7258 130.548 66.8673 130.548 67.0403V69.4516H132.96C133.133 69.4516 133.274 69.5931 133.274 69.7661V71.2339Z",
    fill: "#91D8BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_373_18973",
    x: 68,
    y: -2,
    width: 83,
    height: 101.096,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_373_18973"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_373_18973",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_373_18973",
    x1: 224,
    y1: -77.295,
    x2: -72.707,
    y2: 23.6006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91D8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#F7D780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97B1F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_373_18973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 218,
    height: 89,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPeople);
export default __webpack_public_path__ + "static/media/addPeople.3a5f655892dfe0ba8600587ee06381a2.svg";
export { ForwardRef as ReactComponent };